import { TicketType } from "Api/Api";
import { TicketItemProps } from "Components/Dashboard/TicketListItem/TicketListItem";
import { Colors } from "Components/Models/Colors";
import { TicketReminderIcon } from "Components/Shared/Icons/TicketReminderIcon";
import { TicketWarningIcon } from "Components/Shared/Icons/TicketWarningIcon";
import * as React from "react";
import styled from "styled-components";

type Props = {
  ticket: TicketItemProps;
  iconColor: string;
};

const StyledIconWrapper = styled.div<{ color?: string }>`
  margin-top: 10px;

  & > svg {
    width: 26px;
    height: auto;
  }
`;

const StyledReminderIcon = styled(StyledIconWrapper)`
  svg {
    #triangle {
      fill: ${props => props.color};
    }
  }
`;

const StyledWarningIcon = styled(StyledIconWrapper)`
  svg,
  svg * {
    fill: ${props => props.color};
  }
`;

const getCustomIcon = (customSvgIcon: string) => {
  return (
    <StyledIconWrapper
      dangerouslySetInnerHTML={{ __html: customSvgIcon }}
    ></StyledIconWrapper>
  );
};

const getIcon = (item: TicketItemProps, color: string) => {
  if (item.type === TicketType.Reminder) {
    return (
      <StyledReminderIcon color={color === Colors.Text ? Colors.Blue : color}>
        <TicketReminderIcon />
      </StyledReminderIcon>
    );
  } else {
    return (
      <StyledWarningIcon color={color}>
        <TicketWarningIcon />
      </StyledWarningIcon>
    );
  }
};

export const TicketItemIcon: React.FunctionComponent<Props> = props => {
  const { ticket, iconColor } = props;

  return (
    <>
      {ticket.customSvgIcon ? (
        <>{getCustomIcon(ticket.customSvgIcon)}</>
      ) : (
        <>{getIcon(ticket, iconColor)}</>
      )}
    </>
  );
};
